import type { CopilotMessageEvent } from 'store/entities/copilot/interfaces';

export const isCopilotMessageEvent = (event: unknown): event is CopilotMessageEvent =>
  (event as CopilotMessageEvent)?.type === 'text-message';
